import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ToastrStatus = 'success' | 'error' | 'info' | 'warning';

@Injectable({ providedIn: 'root' })
export class CustomToastrService {
  private toastrSubject = new BehaviorSubject<{ status: ToastrStatus, message: string, show: boolean }>({ status: 'success', message: '', show: false });
  toastrState$ = this.toastrSubject.asObservable();
  private hideTimeout: any;

  show(status: ToastrStatus, message: string, duration: number = 5000) {
    this.toastrSubject.next({ status, message, show: true });
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
    this.hideTimeout = setTimeout(() => {
      this.hide();
    }, duration);
  }

  hide() {
    this.toastrSubject.next({ ...this.toastrSubject.value, show: false });
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
  }
}
